import { render, staticRenderFns } from "./EditShopBookingSettings.vue?vue&type=template&id=2d5bcf7a&scoped=true"
import script from "./EditShopBookingSettings.vue?vue&type=script&lang=js"
export * from "./EditShopBookingSettings.vue?vue&type=script&lang=js"
import style0 from "./EditShopBookingSettings.vue?vue&type=style&index=0&id=2d5bcf7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5bcf7a",
  null
  
)

export default component.exports